import { Component } from '@angular/core';
import { FooterComponent } from 'src/core/index/components.index';

@Component({
  selector: 'meta-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css',]
})
export class CustomFooterComponent extends FooterComponent {

}

